import { convertFromIQueryResponseToIPageData, IPageData } from 'types/rest/IPageData';
import { IEscrowJournalEntryQuery } from '../../types/accounting/query/IEscrowJournalEntryQuery';
import { IEscrowJournalEntryData } from '../../types/accounting/data/IEscrowJournalEntryData';
import { convertFromIPaginationQueryToIPaginationQueryRequest } from '../../types/rest/IPaginationQueryRequest';
import { convertFromISortQueryToISortQueryRequest } from '../../types/rest/ISortQueryRequest';
import {
  IEscrowJournalEntryResponse,
  IEscrowJournalEntriesResponse,
} from '../../types/accounting/response/IEscrowJournalEntryResponse';
import { DateTime } from 'luxon';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';

const convertToApiQuery = ({
  amountCents,
  bankAccountId,
  completedAtDate,
  createdAt,
  entryType,
  escrowFileId,
  fileNumber,
  initiatedAtDate,
  note,
  paymentMethod,
  ...rest
}: IEscrowJournalEntryQuery) => ({
  amountCents,
  bankAccountId,
  entryType,
  escrowFileId,
  fileNumber,
  note,
  paymentMethod,
  createdAtStart: createdAt && DateTime.fromISO(createdAt[0]).toISO(),
  createdAtEnd: createdAt && createdAt[1] && DateTime.fromISO(createdAt[1]).toISO(),
  initiatedAtDateStart: initiatedAtDate && initiatedAtDate[0],
  initiatedAtDateEnd: initiatedAtDate && initiatedAtDate[1],
  completedAtDateStart: completedAtDate && completedAtDate[0],
  completedAtDateEnd: completedAtDate && completedAtDate[1],
  ...convertFromIPaginationQueryToIPaginationQueryRequest(rest),
  ...convertFromISortQueryToISortQueryRequest(rest),
});

//FYI: please preserve this boilerplate to enforce consistency if journal entries needs custom de-serialization
const convertResponseToData = (response: IEscrowJournalEntryResponse): IEscrowJournalEntryData => ({
  ...response,
});

export const getJournalEntriesAsync = async (
  query: IEscrowJournalEntryQuery
): Promise<IPageData<IEscrowJournalEntryData>> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IEscrowJournalEntriesResponse>(`/timber/api/internal/escrow/journal_entries`, {
      params: convertToApiQuery(query),
    })
    .then((response) => convertFromIQueryResponseToIPageData(response.data, convertResponseToData))
    .catch(axiosErrorHandler);
